import { Routes, Route } from 'react-router-dom';
import Main from '../general/js/Main';
import CustomBillPage from '../pages/CustomBills';
import AdditionalPackage from '../pages/AdditionalPackage/AdditionalPackage';
import MainContainer from '../components/MainContainer';
import ProtectedRoute from './ProtectedRoute';
import { HeaderSlotProvider } from '../context/HeaderSlotContext';

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        element={
          <HeaderSlotProvider>
            <Main />
          </HeaderSlotProvider>
        }>
        <Route path="bills/:billId?" element={<CustomBillPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="additional-package" element={<AdditionalPackage />} />
        </Route>
        <Route index element={<MainContainer />} />
      </Route>
    </Routes>
  );
}
